
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M4.5 12C4.63261 12 4.75979 12.0527 4.85355 12.1464C4.94732 12.2402 5 12.3674 5 12.5V16C5 16.2652 5.10536 16.5196 5.29289 16.7071C5.48043 16.8946 5.73478 17 6 17H18C18.2652 17 18.5196 16.8946 18.7071 16.7071C18.8946 16.5196 19 16.2652 19 16V12.5C19 12.3674 19.0527 12.2402 19.1464 12.1464C19.2402 12.0527 19.3674 12 19.5 12C19.6326 12 19.7598 12.0527 19.8536 12.1464C19.9473 12.2402 20 12.3674 20 12.5V16C20 16.5304 19.7893 17.0391 19.4142 17.4142C19.0391 17.7893 18.5304 18 18 18H6C5.46957 18 4.96086 17.7893 4.58579 17.4142C4.21071 17.0391 4 16.5304 4 16V12.5C4 12.3674 4.05268 12.2402 4.14645 12.1464C4.24021 12.0527 4.36739 12 4.5 12Z",
        "fill": "#40454E"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M8.99991 11.4998C9.09367 11.4061 9.22083 11.3534 9.35341 11.3534C9.48599 11.3534 9.61314 11.4061 9.70691 11.4998L11.9999 13.7928L14.2929 11.4998C14.339 11.4521 14.3942 11.414 14.4552 11.3878C14.5162 11.3616 14.5818 11.3478 14.6482 11.3472C14.7146 11.3466 14.7804 11.3593 14.8419 11.3844C14.9033 11.4095 14.9592 11.4467 15.0061 11.4936C15.0531 11.5406 15.0902 11.5964 15.1153 11.6578C15.1405 11.7193 15.1531 11.7851 15.1525 11.8515C15.152 11.9179 15.1382 11.9835 15.112 12.0445C15.0858 12.1055 15.0477 12.1607 14.9999 12.2068L12.3539 14.8538C12.3075 14.9004 12.2523 14.9373 12.1915 14.9625C12.1308 14.9877 12.0657 15.0007 11.9999 15.0007C11.9341 15.0007 11.869 14.9877 11.8083 14.9625C11.7475 14.9373 11.6924 14.9004 11.6459 14.8538L8.99991 12.2068C8.90617 12.113 8.85352 11.9859 8.85352 11.8533C8.85352 11.7207 8.90617 11.5936 8.99991 11.4998Z",
        "fill": "#40454E"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 5C12.1326 5 12.2598 5.05268 12.3536 5.14645C12.4473 5.24021 12.5 5.36739 12.5 5.5V13.5C12.5 13.6326 12.4473 13.7598 12.3536 13.8536C12.2598 13.9473 12.1326 14 12 14C11.8674 14 11.7402 13.9473 11.6464 13.8536C11.5527 13.7598 11.5 13.6326 11.5 13.5V5.5C11.5 5.36739 11.5527 5.24021 11.6464 5.14645C11.7402 5.05268 11.8674 5 12 5Z",
        "fill": "#40454E"
      }
    }
  ]
})
    }
  